export class Contact {
  id: number;
  addressId: number;
  version: number;
  subtype: string;
  contactType: ExternalContactType;
  firstName: string;
  lastName: string;
  fullName: string;
  title: string;
  mobilePhone: string;
  officePhone: string;
  officePhoneExt: number;
  email: string;
  faxPhone: string;
}

export enum ExternalContactType {
  Main = 'MAIN',
  Billing = "BILLING",
  Sales = 'SALES',
  Technical = 'TECHNICAL',
  Other = 'OTHER',
  Owner = 'OWNER'
}